<ion-card>
  <ion-card-header>
    <ion-card-title>Órarend-import és takarítás</ion-card-title>
    <ion-card-subtitle>„Nem naplózott tanórák" lista betöltése — és a csoport nélküli órák tömeges törlése</ion-card-subtitle>
  </ion-card-header>

  <ion-card-content>
    <ion-note color="warning" class="io-bevezeto">
      <b>A sorrend számít: előbb a csoportokat importáld.</b> Az „Osztály/csoport" oszlop
      kétféle lehet — vagy osztálynév („11/G"), vagy csoportnév („9/fg/1/tagozat"). Egy
      éles fájlban 554 sorból <b>335 nem talált célt</b>, amíg a csoportok nem léteztek;
      a csoport-import után egy sem maradt párosítatlanul.
    </ion-note>

    <!-- ══ 0. ELLENŐRZÉS ÉS JAVÍTÁS ══ -->
    <div class="io-lepes">
      <h3><span class="io-szam">0</span> Ellenőrzés és javítás — „miért nem látszik az órarend?"</h3>
      <ion-note color="medium" class="io-sugo">
        Egy import után az órarend <b>üresnek látszhat, pedig a sorok ott vannak</b>. A
        képernyők kötéseken keresztül olvassák az órát, és ami nem talál célt, az nem
        jelenik meg. A leggyakoribb ok: a <b>bontott csoport órája osztály nélkül áll</b>
        (helyesen — több osztályt fog össze), a csoportnak viszont nincs osztály-kötése,
        így az <b>osztály-órarendből kimarad</b>. Ez itt látható és javítható,
        <b>újraimportálás nélkül</b>. Órát nem hozunk létre és nem törlünk.
      </ion-note>
      <div class="io-sor">
        <ion-input label="Ettől" labelPlacement="stacked" type="date" [(ngModel)]="tol"></ion-input>
        <ion-input label="Eddig" labelPlacement="stacked" type="date" [(ngModel)]="ig"></ion-input>
        <ion-button size="default" fill="outline" [disabled]="ellenorzesFut" (click)="ellenorzestFuttat()">
          {{ ellenorzesFut ? 'Ellenőrzés…' : 'Ellenőrzés' }}
        </ion-button>
      </div>

      <div *ngIf="ellenorzes" class="io-elonezet">
        <div class="io-osszegzo">
          <div class="io-kartya" *ngFor="let c of ellenorzes.csoportok">
            <b>{{ c.orak }}</b><span>óra — {{ c.intezmeny }}{{ c.ez_a_nezetben_latszik ? '' : ' (nem látszik!)' }}</span>
          </div>
          <div class="io-kartya" [class.gond]="ellenorzes.kotetlen_orak">
            <b>{{ ellenorzes.kotetlen_orak }}</b><span>óra hiányzik az osztály-órarendből</span>
          </div>
          <div class="io-kartya" [class.gond]="ellenorzes.idegen_orak">
            <b>{{ ellenorzes.idegen_orak }}</b><span>óra idegen tanár-azonosítón</span>
          </div>
          <div class="io-kartya" [class.gond]="ellenorzes.duplikatum?.felesleg">
            <b>{{ ellenorzes.duplikatum?.felesleg || 0 }}</b><span>fölösleges másolat</span>
          </div>
        </div>

        <table class="io-tabla" *ngIf="ellenorzes.kotetlen_csoportok?.length">
          <thead><tr><th>Csoport osztály-kötés nélkül</th><th>Órák</th><th>Mely osztályoké a neve szerint</th></tr></thead>
          <tbody>
            <tr *ngFor="let c of ellenorzes.kotetlen_csoportok">
              <td>{{ c.nev }}</td>
              <td>{{ c.orak }}</td>
              <td>
                {{ c.osztalyok.join(', ') || '—' }}
                <div class="io-gond" *ngIf="c.hianyzo_osztaly?.length">
                  nincs ilyen osztály: {{ c.hianyzo_osztaly.join(', ') }}
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <table class="io-tabla" *ngIf="ellenorzes.idegen_tanarok?.length">
          <thead><tr><th>Idegen tanár-azonosító</th><th>Órák</th><th>A dolgozó saját azonosítója</th></tr></thead>
          <tbody>
            <tr *ngFor="let t of ellenorzes.idegen_tanarok">
              <td>{{ t.nev || '(ismeretlen)' }}<div class="io-halvany">{{ t.adid }}</div></td>
              <td>{{ t.orak }}</td>
              <td>
                {{ t.helyette || '—' }}
                <div class="io-gond" *ngIf="!t.helyette">nincs egyértelmű megfelelője — kézi döntés</div>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="io-javit">
          <label><input type="checkbox" [(ngModel)]="javit.tanar_username" />
            <b>Tanár-azonosító egységesítése</b> — az idegen (gépi) azonosítón álló órák
            átkötése a dolgozó <b>felhasználónevére</b>. Enélkül a tanári órarendben nem
            jelennek meg, mert az a kilét ki sem választható.</label>
          <label><input type="checkbox" [(ngModel)]="javit.duplikatum" />
            <b>Duplikátumok eltávolítása</b> — ugyanaz az óra (nap, óraszám, tanár,
            osztály/csoport, tantárgy) kétszer. Ha az egyik <b>naplózott</b>, az marad meg;
            ha mindkettő naplózott, egyikhez sem nyúlunk.</label>
          <label><input type="checkbox" [(ngModel)]="javit.csoport_osztaly_nevbol" />
            <b>Csoport–osztály kötés a csoport nevéből</b> — „12/fgi/2/mt" → 12/F, 12/G, 12/I.
            Ez hozza vissza a csoportos órákat az osztály-órarendbe.</label>
          <label><input type="checkbox" [(ngModel)]="javit.osztaly_csoportbol" />
            Osztály pótlása a csoportból, ha a csoport <b>egyetlen</b> osztályhoz tartozik</label>
          <label><input type="checkbox" [(ngModel)]="javit.tanev" />
            Hiányzó tanév pótlása a dátumból</label>
          <label><input type="checkbox" [(ngModel)]="javit.tantargy_kerettantervrol" />
            Tantárgy átkötése a kerettantervről a valódi tantárgyra
            <span class="io-halvany">(csak ha a fenti táblázat rossz tantárgyat jelez)</span></label>
          <label><input type="checkbox" [(ngModel)]="javit.intezmeny_atkot" />
            Más feladatellátás-kóddal bekerült órák átkötése ide
            <span class="io-halvany">(csak a saját törzsszámon belül)</span></label>
        </div>

        <ion-button color="primary" [disabled]="javitasFut" (click)="javitastFuttat()">
          <ion-icon slot="start" name="build-outline"></ion-icon>
          {{ javitasFut ? 'Javítás…' : 'Javítás futtatása' }}
        </ion-button>

        <div class="io-elonezet" *ngIf="javitasEredmeny">
          <b>A javítás eredménye:</b>
          <div *ngIf="javitasEredmeny.csoport_osztaly_nevbol">
            csoport–osztály kötés: {{ javitasEredmeny.csoport_osztaly_nevbol.kotes }} új kötés
            ({{ javitasEredmeny.csoport_osztaly_nevbol.csoport }} csoportnál)
          </div>
          <div *ngIf="javitasEredmeny.osztaly_csoportbol">osztály pótolva: {{ javitasEredmeny.osztaly_csoportbol }} óra</div>
          <div *ngIf="javitasEredmeny.tanev">tanév pótolva: {{ javitasEredmeny.tanev }} óra</div>
          <div *ngIf="javitasEredmeny.tantargy_kerettantervrol">tantárgy átkötve: {{ javitasEredmeny.tantargy_kerettantervrol }} óra</div>
          <div *ngIf="javitasEredmeny.intezmeny_atkot">intézmény átkötve: {{ javitasEredmeny.intezmeny_atkot }} óra</div>
        </div>
      </div>
    </div>

    <!-- ══ 1. TAKARÍTÁS ══ -->
    <div class="io-lepes io-veszelyes">
      <h3><span class="io-szam">1</span> Takarítás — csoport nélküli órák törlése</h3>
      <ion-note color="medium" class="io-sugo">
        Ez <b>nem rutinművelet</b>: a csoport nélküli óra a normális eset, minden
        osztályszintű tanóra ilyen. Akkor van rá szükség, ha az órarend rosszul került be
        (például a csoportok még nem léteztek, így minden óra osztályszinten landolt).
        Ezért kötelező az <b>időszak</b>, és ezért <b>nem töröljük</b> a már naplózott
        órát: abban hiányzás, igazolás, dicséret van — az órát újra fel lehet vinni, a
        beírt adatot nem.
      </ion-note>
      <div class="io-sor">
        <ion-input label="Ettől" labelPlacement="stacked" type="date" [(ngModel)]="tol"></ion-input>
        <ion-input label="Eddig" labelPlacement="stacked" type="date" [(ngModel)]="ig"></ion-input>
        <ion-button size="default" fill="outline" (click)="torlestNez()">Előnézet</ion-button>
      </div>

      <div *ngIf="torlesElonezet" class="io-elonezet">
        <div class="io-osszegzo">
          <div class="io-kartya"><b>{{ torlesElonezet.osszes }}</b><span>csoport nélküli óra</span></div>
          <div class="io-kartya"><b>{{ torlesElonezet.torolheto }}</b><span>törölhető</span></div>
          <div class="io-kartya" [class.gond]="torlesElonezet.naplozott">
            <b>{{ torlesElonezet.naplozott }}</b><span>már naplózott</span></div>
          <div class="io-kartya"><b>{{ torlesElonezet.erintetlen_csoportos }}</b><span>csoportos — érintetlen</span></div>
        </div>
        <div class="io-napok" *ngIf="torlesElonezet.napok?.length">
          <span *ngFor="let n of torlesElonezet.napok">{{ n.datum | date:'yyyy-MM-dd' }}: <b>{{ n.db }}</b></span>
        </div>
        <ion-checkbox labelPlacement="end" [(ngModel)]="naplozottatIs" *ngIf="torlesElonezet.naplozott">
          A már naplózott órákat is töröljem — a bennük lévő hiányzás és dicséret elvész
        </ion-checkbox>
        <div style="margin-top:10px">
          <ion-button color="danger" [disabled]="torlesFut || !torlesElonezet.osszes" (click)="torol()">
            <ion-icon slot="start" name="trash-outline"></ion-icon>
            {{ torlesFut ? 'Fut…' : 'Törlés' }}
          </ion-button>
        </div>
        <div *ngIf="torlesEredmeny" class="io-eredmeny">
          <b>{{ torlesEredmeny.torolve }}</b> óra törölve.
          <span *ngIf="torlesEredmeny.megtartott_naplozott">
            {{ torlesEredmeny.megtartott_naplozott }} naplózott órát megtartottunk.</span>
        </div>
      </div>
    </div>

    <!-- ══ 5. TERMEK PÓTLÁSA ══ -->
    <div class="io-lepes">
      <h3><span class="io-szam">5</span> Termek pótlása</h3>
      <ion-note color="medium" class="io-sugo">
        Az órarendben a terem <b>kötelező</b> mező, a betöltésre használt lista viszont
        nem tartalmazza — az import ezért minden órát <b>egy</b> terembe tesz. Ez a
        művelet egy olyan táblából pótolja, amiben az óra mellett ott a terem is (aSc
        órarend-kiírás, vagy bármely export terem-oszloppal).<br>
        A párosítás kulcsa: <b>hét napja + óraszám + osztály/csoport + tantárgy + tanár</b>.
        Egy forrássor tehát az időszak <b>minden</b> olyan napjára hat, ahol az az óra
        szerepel. Az időszakot fent, a takarításnál add meg.
      </ion-note>

      <input #tFajlValaszto type="file" accept=".xlsx,.xls,.csv" hidden (change)="tFajlValtozott($event)" />
      <div class="io-sor">
        <ion-button size="default" fill="outline" (click)="tFajlValaszto.click()">
          <ion-icon slot="start" name="document-attach-outline"></ion-icon>
          {{ tFajlNev ? 'Másik fájl' : 'Terem-forrás kiválasztása' }}
        </ion-button>
        <span class="io-fajl" *ngIf="tFajlNev">{{ tFajlNev }} — <b>{{ tNyers.length }}</b> sor</span>
      </div>

      <div class="io-sor" *ngIf="tFejlecek.length">
        <ion-select label="Nap *" labelPlacement="stacked" interface="popover" [(ngModel)]="tOszlop.nap">
          <ion-select-option *ngFor="let f of tFejlecek" [value]="f">{{ f }}</ion-select-option>
        </ion-select>
        <ion-select label="Óraszám" labelPlacement="stacked" interface="popover" [(ngModel)]="tOszlop.ora">
          <ion-select-option value="">—</ion-select-option>
          <ion-select-option *ngFor="let f of tFejlecek" [value]="f">{{ f }}</ion-select-option>
        </ion-select>
        <ion-select label="Osztály/csoport *" labelPlacement="stacked" interface="popover" [(ngModel)]="tOszlop.osztaly">
          <ion-select-option *ngFor="let f of tFejlecek" [value]="f">{{ f }}</ion-select-option>
        </ion-select>
        <ion-select label="Tantárgy" labelPlacement="stacked" interface="popover" [(ngModel)]="tOszlop.tantargy">
          <ion-select-option value="">—</ion-select-option>
          <ion-select-option *ngFor="let f of tFejlecek" [value]="f">{{ f }}</ion-select-option>
        </ion-select>
        <ion-select label="Tanár" labelPlacement="stacked" interface="popover" [(ngModel)]="tOszlop.tanar">
          <ion-select-option value="">—</ion-select-option>
          <ion-select-option *ngFor="let f of tFejlecek" [value]="f">{{ f }}</ion-select-option>
        </ion-select>
        <ion-select label="Terem *" labelPlacement="stacked" interface="popover" [(ngModel)]="tOszlop.terem">
          <ion-select-option *ngFor="let f of tFejlecek" [value]="f">{{ f }}</ion-select-option>
        </ion-select>
      </div>

      <div class="io-sor" *ngIf="tFejlecek.length">
        <ion-select label="Gyűjtő terem (amibe az import tett mindent)" labelPlacement="stacked"
                    interface="popover" [(ngModel)]="gyujtoTerem">
          <ion-select-option value="">— mindegy, bármelyiket felülírhatja —</ion-select-option>
          <ion-select-option *ngFor="let t of termek" [value]="t.id">{{ t.name }}</ion-select-option>
        </ion-select>
        <ion-button size="default" color="primary" [disabled]="tElemzesFut" (click)="teremElemez()">
          {{ tElemzesFut ? 'Elemzés…' : 'Elemzés (' + tKuldheto.length + ' sor)' }}
        </ion-button>
      </div>
      <ion-note color="warning" class="io-sugo" *ngIf="tFejlecek.length && !gyujtoTerem">
        Gyűjtő terem nélkül a <b>kézzel beállított, helyes termeket is</b> felülírhatja
        egy hibás forrássor. Ha az import egy „nincs megadva" jellegű terembe tett
        mindent, válaszd ki azt — akkor csak azokhoz nyúlunk.
      </ion-note>

      <ng-container *ngIf="tElemzes">
        <div class="io-osszegzo">
          <div class="io-kartya"><b>{{ tElemzes.osszegzes.hasznalhato }}</b><span>használható forrássor</span></div>
          <div class="io-kartya"><b>{{ tElemzes.osszegzes.erintett_ora }}</b><span>óra kapna termet</span></div>
          <div class="io-kartya" [class.gond]="tElemzes.osszegzes.nincs_talalat">
            <b>{{ tElemzes.osszegzes.nincs_talalat }}</b><span>forrássorhoz nincs óra</span></div>
          <div class="io-kartya" [class.gond]="tElemzes.osszegzes.hibas">
            <b>{{ tElemzes.osszegzes.hibas }}</b><span>hibás forrássor</span></div>
          <div class="io-kartya" [class.gond]="tElemzes.osszegzes.fedetlen_ora">
            <b>{{ tElemzes.osszegzes.fedetlen_ora }}</b><span>óra terem nélkül maradna</span></div>
        </div>

        <ion-button color="primary" [disabled]="tFut || !tElemzes.osszegzes.erintett_ora" (click)="teremPotol()">
          <ion-icon slot="start" name="business-outline"></ion-icon>
          {{ tFut ? 'Fut…' : 'Termek pótlása' }}
        </ion-button>
        <div *ngIf="tEredmeny" class="io-eredmeny"><b>{{ tEredmeny.modositott }}</b> óra terme pótolva.</div>

        <!-- „Ha valahova nem találsz, a végén listázd ki" -->
        <h4 class="io-alcim" *ngIf="tElemzes.fedetlen?.length">
          Ide nem találunk termet ({{ tElemzes.osszegzes.fedetlen_ora }} óra)
        </h4>
        <table class="io-tabla" *ngIf="tElemzes.fedetlen?.length">
          <thead><tr><th>Nap</th><th>Óra</th><th>Osztály/csoport</th><th>Tantárgy</th><th>Tanár</th><th>Órák</th></tr></thead>
          <tbody>
            <tr *ngFor="let f of tElemzes.fedetlen">
              <td>{{ f.nap }}</td><td>{{ f.ora }}</td><td>{{ f.cel }}</td>
              <td>{{ f.tantargy }}</td><td>{{ f.tanar }}</td><td>{{ f.db }}</td>
            </tr>
          </tbody>
        </table>

        <h4 class="io-alcim" *ngIf="tElemzes.osszegzes.hibas || tElemzes.osszegzes.nincs_talalat">
          Forrássorok, amiket nem tudtunk használni
        </h4>
        <table class="io-tabla" *ngIf="tElemzes.osszegzes.hibas || tElemzes.osszegzes.nincs_talalat">
          <thead><tr><th>Nap</th><th>Óra</th><th>Osztály/csoport</th><th>Terem</th><th>Miért</th></tr></thead>
          <tbody>
            <tr *ngFor="let s of tElemzes.sorok">
              <ng-container *ngIf="s.allapot !== 'ok'">
                <td>{{ s.nap }}</td><td>{{ s.ora }}</td><td>{{ s.cel }}</td><td>{{ s.terem_nev }}</td>
                <td>
                  <span *ngIf="s.allapot === 'nincs_talalat'" class="io-halvany">nincs ilyen óra az időszakban</span>
                  <div class="io-gond" *ngFor="let g of s.gondok">{{ g }}</div>
                </td>
              </ng-container>
            </tr>
          </tbody>
        </table>
      </ng-container>
    </div>

    <!-- ══ 2. FÁJL ══ -->
    <div class="io-lepes">
      <h3><span class="io-szam">2</span> Fájl</h3>
      <input #fajlValaszto type="file" accept=".xlsx,.xls,.csv" hidden (change)="fajlValtozott($event)" />
      <div class="io-sor">
        <ion-button size="default" fill="outline" (click)="fajlValaszto.click()">
          <ion-icon slot="start" name="document-attach-outline"></ion-icon>
          {{ fajlNev ? 'Másik fájl' : 'Fájl kiválasztása' }}
        </ion-button>
        <span class="io-fajl" *ngIf="fajlNev">{{ fajlNev }} — <b>{{ nyersSorok.length }}</b> sor</span>
        <span class="io-fajl halvany" *ngIf="!fajlNev">Excel (.xlsx/.xls) vagy CSV</span>
      </div>
    </div>

    <!-- ══ 3. OSZLOPOK ══ -->
    <div class="io-lepes" *ngIf="fejlecek.length">
      <h3><span class="io-szam">3</span> Melyik oszlop mit jelent?</h3>
      <div class="io-sor">
        <ion-select label="Dátum *" labelPlacement="stacked" interface="popover" [(ngModel)]="oszlop.datum">
          <ion-select-option *ngFor="let f of fejlecek" [value]="f">{{ f }}</ion-select-option>
        </ion-select>
        <ion-select label="Óraszám" labelPlacement="stacked" interface="popover" [(ngModel)]="oszlop.ora">
          <ion-select-option value="">—</ion-select-option>
          <ion-select-option *ngFor="let f of fejlecek" [value]="f">{{ f }}</ion-select-option>
        </ion-select>
        <ion-select label="Osztály/csoport *" labelPlacement="stacked" interface="popover" [(ngModel)]="oszlop.osztaly">
          <ion-select-option *ngFor="let f of fejlecek" [value]="f">{{ f }}</ion-select-option>
        </ion-select>
        <ion-select label="Tantárgy" labelPlacement="stacked" interface="popover" [(ngModel)]="oszlop.tantargy">
          <ion-select-option value="">—</ion-select-option>
          <ion-select-option *ngFor="let f of fejlecek" [value]="f">{{ f }}</ion-select-option>
        </ion-select>
        <ion-select label="Tanár" labelPlacement="stacked" interface="popover" [(ngModel)]="oszlop.tanar">
          <ion-select-option value="">—</ion-select-option>
          <ion-select-option *ngFor="let f of fejlecek" [value]="f">{{ f }}</ion-select-option>
        </ion-select>
      </div>
      <ion-button color="primary" [disabled]="!oszlop.datum || !oszlop.osztaly || elemzesFut" (click)="elemez()">
        <ion-icon slot="start" name="search-outline"></ion-icon>
        {{ elemzesFut ? 'Elemzés…' : 'Elemzés (' + kuldhetoSorok.length + ' sor)' }}
      </ion-button>
    </div>

    <!-- ══ 4. ELEMZÉS ══ -->
    <ng-container *ngIf="elemzes">
      <div class="io-lepes">
        <h3><span class="io-szam">4</span> Amit találtunk</h3>
        <div class="io-osszegzo">
          <div class="io-kartya"><b>{{ elemzes.osszegzes.felviheto }}</b><span>felvihető</span></div>
          <div class="io-kartya"><b>{{ elemzes.osszegzes.mar_bent }}</b><span>már bent van</span></div>
          <div class="io-kartya" [class.gond]="elemzes.osszegzes.hibas"><b>{{ elemzes.osszegzes.hibas }}</b><span>hibás</span></div>
          <div class="io-kartya"><b>{{ elemzes.osszegzes.csoportos }}</b><span>csoportos óra</span></div>
          <div class="io-kartya"><b>{{ elemzes.osszegzes.napok.length }}</b><span>nap</span></div>
        </div>
        <p class="io-napsor" *ngIf="elemzes.osszegzes.napok?.length">
          {{ elemzes.osszegzes.napok[0] }} – {{ elemzes.osszegzes.napok[elemzes.osszegzes.napok.length - 1] }}
        </p>

        <div class="io-hiany" *ngIf="elemzes.hianyzo_cel?.length">
          <b>Nincs ilyen osztály vagy csoport ({{ elemzes.hianyzo_cel.length }}):</b>
          {{ elemzes.hianyzo_cel.join(', ') }}
          <div class="io-tipp">Ezek jellemzően <b>csoportok</b> — futtasd le előbb a csoport-importot.</div>
        </div>
        <div class="io-hiany" *ngIf="elemzes.hianyzo_tantargy?.length">
          <b>Nincs ilyen tantárgy ({{ elemzes.hianyzo_tantargy.length }}):</b>
          {{ elemzes.hianyzo_tantargy.join(', ') }}
        </div>
        <div class="io-hiany" *ngIf="elemzes.hianyzo_tanar?.length">
          <b>Nincs ilyen munkatárs ({{ elemzes.hianyzo_tanar.length }}):</b>
          {{ elemzes.hianyzo_tanar.join(', ') }}
          <div class="io-tipp">Munkatársat <b>nem hozunk létre</b> import közben — a rossz
            tanárhoz felvitt óra csendesebb hiba, mint a kimaradt sor.</div>
        </div>

        <div class="io-sor" style="margin-top:12px">
          <ion-select label="Terem *" labelPlacement="stacked" interface="popover" [(ngModel)]="terem">
            <ion-select-option *ngFor="let t of termek" [value]="t.id">{{ t.name }}</ion-select-option>
          </ion-select>
          <ion-checkbox labelPlacement="end" [(ngModel)]="tantargyLetrehoz"
                        *ngIf="elemzes.hianyzo_tantargy?.length">
            A hiányzó tantárgyakat hozzuk létre ({{ elemzes.hianyzo_tantargy.length }} db)
          </ion-checkbox>
        </div>
        <ion-note color="medium" class="io-sugo">
          A terem az órarendben kötelező mező, a lista viszont nem tartalmazza — ezért kell
          megadni. Nem találunk ki termet: egy rossz terem az órarendben látszólag rendben van.
        </ion-note>

        <ion-button color="primary" [disabled]="fut || !elemzes.osszegzes.felviheto || !terem" (click)="importal()">
          <ion-icon slot="start" name="cloud-upload-outline"></ion-icon>
          {{ fut ? 'Fut…' : 'Import (' + elemzes.osszegzes.felviheto + ' óra)' }}
        </ion-button>

        <div *ngIf="eredmeny" class="io-eredmeny">
          <b>{{ eredmeny.felvive }}</b> óra felvive,
          <b>{{ eredmeny.mar_bent }}</b> már bent volt,
          <b>{{ eredmeny.hibas }}</b> hibás sor kimaradt.
          <span *ngIf="eredmeny.tantargy_uj">{{ eredmeny.tantargy_uj }} új tantárgy létrehozva.</span>
        </div>
      </div>

      <!-- Sorok -->
      <div class="io-lepes">
        <h3>
          Sorok
          <ion-checkbox labelPlacement="end" [(ngModel)]="csakHibas" style="font-size:12px;margin-left:12px">
            csak a hibásak
          </ion-checkbox>
        </h3>
        <table class="io-tabla">
          <thead>
            <tr><th>Dátum</th><th>Óra</th><th>Osztály/csoport</th><th>Tantárgy</th><th>Tanár</th><th>Állapot</th></tr>
          </thead>
          <tbody>
            <tr *ngFor="let s of mutatottSorok">
              <td>{{ s.datum }}</td>
              <td>{{ s.ora }}</td>
              <td>
                {{ s.cel }}
                <span class="io-jel" *ngIf="s.cel_tipus === 'csoport'">csoport</span>
                <div class="io-halvany" *ngIf="s.osztaly_nev">osztály: {{ s.osztaly_nev }}</div>
              </td>
              <td>{{ s.tantargy_nev }}</td>
              <td>{{ s.tanar_nev }}</td>
              <td>
                <span class="io-jel" [class.ok]="s.allapot === 'ok'" [class.gond]="s.allapot === 'hibas'">
                  {{ s.allapot }}
                </span>
                <div class="io-gond" *ngFor="let g of s.gondok">{{ g }}</div>
              </td>
            </tr>
          </tbody>
        </table>
        <p class="io-halvany" *ngIf="!mutatottSorok.length">Nincs megjelenítendő sor.</p>
      </div>
    </ng-container>
  </ion-card-content>
</ion-card>
